import {
  TopIssuers,
  TopRatingAgencies,
  TopUnderwriters,
} from '@/creditflowresearch/ui/components/TopCompanies/TopCompaniesTables';
import {
  CorporateRatingAgencies,
  CorporateTopIssuers,
  CorporateTopUnderwriters,
} from '@/creditflowresearch/ui/components/TopCompanies/TopCompaniesTables/CorporateTables';

export const ISSUER_NAME = 'issuer';
export const PARENT_NAME = 'parent';
export const RATING_AGENCY_NAME = 'ratingAgency';
export const UNDERWRITER_NAME = 'underwriter';

export const TOP_COMPANIES_CONFIG = {
  [ISSUER_NAME]: {
    title: 'Top Issuers',
    component: TopIssuers,
  },
  [PARENT_NAME]: {
    title: 'Issuers',
    component: TopIssuers,
  },
  [RATING_AGENCY_NAME]: {
    title: 'Top Rating Agencies',
    component: TopRatingAgencies,
  },
  [UNDERWRITER_NAME]: {
    title: 'Top Underwriters',
    component: TopUnderwriters,
  },
};

export const CORPORATE_TOP_COMPANIES_CONFIG = {
  [PARENT_NAME]: {
    title: 'Top Issuers',
    component: CorporateTopIssuers,
  },
  [RATING_AGENCY_NAME]: {
    title: 'Top Rating Agencies',
    component: CorporateRatingAgencies,
  },
  [UNDERWRITER_NAME]: {
    title: 'Top Underwriters',
    component: CorporateTopUnderwriters,
  },
};
